export const BOOKING_STATUS = {
  AWAITING_REVIEW: 0,
  APPROVED: 1,
  REFUSED: 2,
  CANCELLED: 3,
  USER_CANCELLED: 4,
  AWAITING_PAYMENT: 5,
  CANCELLED_PAYMENT: 6,
};
